import { Card, Row, Col } from 'antd';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { DetailRow } from './DetailRow';

/**
 * RoomDetailsCard - Displays room booking information with upgrade badges if applicable
 */
const RoomDetailsCard = ({ roomDetails }) => {
    if (!roomDetails || roomDetails.length === 0) return null;

    return (
        <Card
            className="mb-3"
            headStyle={{
                background: '#1890ff',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                padding: '16px 24px',
            }}
            bodyStyle={{ padding: '24px' }}
            bordered={false}
            title={<span style={{ color: '#fff', fontSize: '18px', fontWeight: '600' }}>Room Details</span>}
        >
            {roomDetails.map((room, index) => (
                <div
                    key={index}
                    className={index > 0 ? 'mt-3 pt-3' : ''}
                    style={{
                        ...(index > 0 ? { borderTop: '1px solid #f0f0f0' } : {}),
                        ...(room.isUpgraded ? {
                            background: 'linear-gradient(135deg, #fff9e6 0%, #ffffff 100%)',
                            padding: '16px',
                            borderRadius: '8px',
                            border: '2px solid #ffd666',
                            position: 'relative'
                        } : {})
                    }}
                >
                    {room.isUpgraded && (
                        <div style={{
                            position: 'absolute',
                            top: '-10px',
                            right: '16px',
                            background: 'linear-gradient(135deg, #faad14 0%, #fa8c16 100%)',
                            color: '#fff',
                            padding: '4px 12px',
                            borderRadius: '12px',
                            fontSize: '11px',
                            fontWeight: '700',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            boxShadow: '0 2px 8px rgba(250, 173, 20, 0.3)'
                        }}>
                            <FeatherIcon icon="trending-up" size={12} />
                            UPGRADED
                        </div>
                    )}

                    {room.isUpgraded && room.upgradedFrom && (
                        <div style={{
                            background: '#fffbe6',
                            border: '1px solid #ffe58f',
                            borderRadius: '6px',
                            padding: '10px 12px',
                            marginBottom: '16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <FeatherIcon icon="arrow-up-circle" size={16} style={{ color: '#faad14', flexShrink: 0 }} />
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: '11px', color: '#8c8c8c', marginBottom: '2px' }}>
                                    Upgraded from
                                </div>
                                <div style={{ fontSize: '13px', fontWeight: '600', color: '#262626' }}>
                                    {room.upgradedFrom.roomTypeName}
                                </div>
                                {room.upgradedFrom.upgradeDate && (
                                    <div style={{ fontSize: '10px', color: '#8c8c8c', marginTop: '2px' }}>
                                        {new Date(room.upgradedFrom.upgradeDate).toLocaleDateString()} at {new Date(room.upgradedFrom.upgradeDate).toLocaleTimeString()}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    <Row gutter={[24, 0]}>
                        <Col xs={24} md={12}>
                            <DetailRow icon="home" label="Room Type" value={room.roomTypeName} />
                            <DetailRow icon="user" label="Booked For" value={room.customerName} />
                            <DetailRow icon="users" label="Gender" value={room.gender} />
                        </Col>
                        <Col xs={24} md={12}>
                            <DetailRow icon="grid" label="Occupancy Mode" value={room.occupancyMode} />
                            <DetailRow icon="dollar-sign" label="Price Per Day" value={`₹${room.pricePerDay}`} />
                            <DetailRow icon="dollar-sign" label="Total Price" value={`₹${room.totalPrice}`} />
                        </Col>
                    </Row>
                </div>
            ))}
        </Card>
    );
};

export default RoomDetailsCard;
